import React from 'react';
import { Container, Content, Header, Podium, ShimmerEffect } from './styles';

// import { Container } from './styles';

const LoadingState: React.FC = () => {
  return (
    <Container>
      <Header>
        <ShimmerEffect className="filter-shimmer" />
      </Header>
      <Content>
        <Podium>
          <ShimmerEffect className="podium-shimmer" />
          <ShimmerEffect className="podium-shimmer" />
          <ShimmerEffect className="podium-shimmer" />
        </Podium>

        <ShimmerEffect className="list-shimmer" />
      </Content>
    </Container>
  );
};

export default LoadingState;
